
import { AreaPacienteProvider } from "@/components/AreaPaciente/AreaPacienteProvider";
import { AreaPacienteContent } from "@/components/AreaPaciente/AreaPacienteContent";

export default function AreaPaciente() {
  return (
    <AreaPacienteProvider>
      <AreaPacienteContent />
    </AreaPacienteProvider>
  );
}
